import DualSense from "../DualSense";
import XM4 from "../XM4";
import Football from "../Football";

export const MODELS = [DualSense, XM4, Football];
